const getCurrentURL = () => {
  if (typeof window === 'undefined') return

  const { protocol, host } = window.location
  return `${protocol}//${host}`
}

export const getPublicUrl = () =>
  process.env.NEXT_PUBLIC_URL || getCurrentURL() || 'https://account.mmhmm.app'
